"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findSelfIntersections = findSelfIntersections;
var _computeBbox = require("./computeBbox");
var _intersectEntities = require("./intersectEntities");
// Note: there is a faster algorithm that works for line segments, the Bentley-Ottmann algorithm, but it's complicated

/**
 * Finds points of intersection between the entities
 * @param contour A contour, containing an array of entities
 */
function findSelfIntersections(contour) {
  // TODO: An arc and a line, or two arcs, that are consecutive, could still potentially intersect like this:
  /*
         _____  
        /     \
  _____/_______\
      |
       \
  */
  // Do we really want to test every pair of consecutive entities for this? (It will be quick to see whether a supposed intersection is actually an endpoint.)

  const symBbox = Symbol('bbox');

  // Precompute bounding boxes on each entity
  for (let e of contour.entities) {
    e[symBbox] = (0, _computeBbox.computeBbox)([e]);
  }
  const intersectingPoints = [];
  for (let i = 0; i < contour.entities.length; i++) {
    const e0 = contour.entities[i];
    for (let j = i + 2; j < contour.entities.length; j++) {
      if (contour.isClosed && i === 0 && j === contour.entities.length - 1) continue;
      const e1 = contour.entities[j];

      // Check bounding boxes
      if (e0[symBbox].max.x < e1[symBbox].min.x) continue;
      if (e0[symBbox].min.x > e1[symBbox].max.x) continue;
      if (e0[symBbox].max.y < e1[symBbox].min.y) continue;
      if (e0[symBbox].min.y > e1[symBbox].max.y) continue;
      intersectingPoints.push(...(0, _intersectEntities.intersectEntities)(e0, e1));
    }
  }

  // There is no mechanism to retain these bounding boxes, because in practice this function will only be called once
  // for each contour.
  for (let e of contour.entities) {
    delete e[symBbox];
  }
  return intersectingPoints;
}